import { useEffect } from 'react';

import usePageContext from '@rover/react-lib/src/context/usePageContext';
import { FLAGS } from '@rover/rsdk/src/modules/Data/Core/FrontendConfiguration';
import useCountryConfigurationShim from '@rover/shared/js/hooks/useCountryConfigurationShim';
import useCurrentUserShim from '@rover/shared/js/hooks/useCurrentUserShim';
import useFrontendConfigurationShim from '@rover/shared/js/hooks/useFrontendConfigurationShim';
import configureAlooma from '@rover/utilities/configureAlooma';
import emitMetric from '@rover/utilities/emitMetric';
import loadNavigationEventsIntoDataLayer from '@rover/utilities/loadNavigationEventsIntoDataLayer';
import { redirect } from '@rover/utilities/url';

const usePageLoadHandler = (): void => {
  const { isIdentityVerificationRequired, user } = useCurrentUserShim();
  const { language, isFlagActive } = useFrontendConfigurationShim();
  const { current: cc } = useCountryConfigurationShim();
  const route = usePageContext();

  const countryCode = cc?.countryCode ?? 'US';
  const { pageCategory, pageName } = route;
  const enableAmplitudeAnalytics = isFlagActive(FLAGS.ROLLOUT_AMPLITUDE_ANALYTICS_WEB);

  useEffect(() => {
    if (isIdentityVerificationRequired) {
      redirect('/people/identity-verification/');
    }
  }, [isIdentityVerificationRequired]);

  useEffect(() => {
    configureAlooma({
      currentUser: user,
      pageCategory,
      language,
      countryCode,
      enableAmplitudeAnalytics,
    });
    loadNavigationEventsIntoDataLayer();
    emitMetric('screen_view', { screen_name: pageName, is_ucp: 'true' });
  }, [language, user, countryCode, pageCategory, pageName, enableAmplitudeAnalytics]);
};

export default usePageLoadHandler;
